/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueSystemCategoryOptionsComponent } from './sysque-system-category-options.component';
import { DxButtonModule, DxSelectBoxModule } from 'devextreme-angular';
import { SysqueFrameModule } from 'libs/sysque/shared/ui/src/lib/components/sysque-frame';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [
  {
    path: 'dialog/create-system-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: true, isSystemOperation: true, isDuplicateOperation: false },
  },
  {
    path: 'dialog/rename-system-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: false, isSystemOperation: true, isDuplicateOperation: false },
  },
  {
    path: 'dialog/create-category-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: true, isSystemOperation: false, isDuplicateOperation: false },
  },
  {
    path: 'dialog/rename-category-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: false, isSystemOperation: false, isDuplicateOperation: false },
  },
  {
    path: 'dialog/duplicate-system-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: false, isSystemOperation: false, isDuplicateOperation: true },
  },
];

@NgModule({
  declarations: [SysqueSystemCategoryOptionsComponent],
  imports: [
    CommonModule,
    SysqueFrameModule,
    FormsModule,
    AlertModule,
    DxButtonModule,
    DxSelectBoxModule,
    RouterModule.forChild(routes),
  ],
  exports: [SysqueSystemCategoryOptionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SysqueSystemCategoryOptionsModule {}
